<template>
  <InputGroup>
    <InputText placeholder="Search Icons" v-model="searchQuery" @keyup.enter="requestImages" />
    <Button icon="pi pi-search" severity="info" @click="requestImages" />
  </InputGroup>

  <div v-if="fetchingIcons">
    <div class="skeleton-grid">
      <div class="skeleton-item" v-for="index in 12" :key="index">
        <Skeleton size="230px" />
      </div>
    </div>
  </div>

  <div v-else-if="thumbnailUrls.length > 0">
    <div class="img-grid">
      <div class="img-item" v-for="url in thumbnailUrls" >
        <Image :src="url" alt="" @click="emitChosenFile($event)" ref="imageRef" />
      </div>
    </div>
  </div>

  <div v-else-if="hasSearched && !fetchingIcons && thumbnailUrls.length === 0">
    <p style="margin-top: 25px;font-size: 14px;">No results found. Try another search term.</p>
  </div>

</template>

<script setup lang="ts">
import {ref} from "vue";

const searchQuery = ref('')
const fetchingIcons = ref(false)
const hasSearched = ref(false)
const thumbnailUrls = ref([])
const imageRef = ref();

const emit = defineEmits(['fileChosen']);

const requestImages = async () => {
  thumbnailUrls.value = []
  fetchingIcons.value = true

  const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/stock-images`, {
    method: 'POST',
    body: JSON.stringify({ query: searchQuery.value })
  })

  const data = await response.json()

  if (data.result.length === 0) {
    hasSearched.value = true
    fetchingIcons.value = false
  } else {
  for (let image of data.result) {
    thumbnailUrls.value.push(image.url_big);
  }
  fetchingIcons.value = false
    }
}

const emitChosenFile = (event) => {
  const clickedImageElement = event.target; // Get the clicked image element

  const url = clickedImageElement.src

  emit('fileChosen', {
    url: url,
    width: clickedImageElement.naturalWidth,
    height: clickedImageElement.naturalHeight
  })


}
</script>

<style scoped lang="scss">
.skeleton-grid {
  padding-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.skeleton-item {
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.img-grid {
  padding-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.img-item {
  width: 230px;
  height: 230px;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

:deep(.img-item > .p-image.p-component > img) {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

:deep(.img-item > .p-image.p-component > img:hover) {
  cursor: pointer;
}
</style>